// libs
import React, { memo } from "react";

// global components
import WithStyles from "shared/components/WithStyles";

// styles
import { FourOFourStyles } from "./styles";

// constants
import { TEXT } from "./constants";

function NotFoundError() {
    return (
        <WithStyles cssProps={FourOFourStyles}>
            <div className="brokenPage">
                <div className="brokenLink icon-broken-link" />
                <div className="msg404">{TEXT.FOUR_O_FOUR}</div>
                <div className="brokenmsg">{TEXT.BROKEN_MSG}</div>
                <div className="corruptmsg">{TEXT.CORRUPT_MSG}</div>
                <a href="/" className="goBack">
                    {TEXT.HOME_LINK_LABEL}
                </a>
            </div>
        </WithStyles>
    );
}

export default memo(NotFoundError);
